import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { callIfChanged } from 'utilities/forms';

import { generateDistributionData } from 'store/scenes/distributions/actions';
import { getDistributionsFormValues } from 'store/form/distributions/selectors';

import FisherDistributionFieldsComponent from './Component';

class FisherDistributionFieldsContainer extends React.PureComponent {
  static propTypes = {
    generateDistributionData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    const makeHandleChangeFn = property => callIfChanged((_, newValue) => {
      setTimeout(() => this.props.generateDistributionData({ [property]: newValue }));
    });

    this.handleNumeratorChange = makeHandleChangeFn('numeratorDf');
    this.handleDenominatorChange = makeHandleChangeFn('denominatorDf');
  }

  render () {
    return (
      <FisherDistributionFieldsComponent
        onNumeratorChange={this.handleNumeratorChange}
        onDenominatorChange={this.handleDenominatorChange}
      />
    );
  }
}

const mapDispatchToProps = {
  generateDistributionData: values => (dispatch, getState) => {
    const distributionFormValues = getDistributionsFormValues(getState());
    dispatch(generateDistributionData({ ...distributionFormValues, ...values }));
  }
};

export default connect(null, mapDispatchToProps)(
  FisherDistributionFieldsContainer
);
